// API Base URL
// For local development, use: 'http://localhost:5000/api'
// For production, use: 'https://pronest-31n7.onrender.com/api'
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// App Info
export const APP_NAME = process.env.REACT_APP_NAME || 'ProNest';

// Product Categories
export const CATEGORIES = [
  'All',
  'Electronics',
  'Mobiles & Accessories',
  'Computers & Accessories',
  'Audio & Video',
  'Cameras & Accessories',
  'Smart Devices',
  'Smartphones',
  'Headphones',
  'Laptops',
  'Keyboards',
  'Televisions',
  'Washing Machines',
  'Refrigerators',
  'Air Conditioners',
  'Tablets',
  'Smart Watches',
  'Power Banks',
  'Gaming Consoles',

  'Fashion',
  'Men Clothing',
  'Women Clothing',
  'Kids Clothing',
  'Footwear',
  'Fashion Accessories',
  'Watches',
  'Jewelry',
  'Bags',

  'Home & Living',
  'Furniture',
  'Home Decor',
  'Kitchen & Dining',
  'Kitchenware',
  'Bedding & Bath',
  'Beds',
  'Mattresses',
  'Curtains',
  'Wall Clocks',
  'Storage Containers',

  'Beauty & Personal Care',
  'Makeup',
  'Skincare',
  'Haircare',
  'Personal Care Appliances',

  'Grocery & Essentials',
  'Food & Beverages',
  'Fruits & Vegetables',
  'Dairy & Bakery',
  'Household Supplies',

  'Health & Wellness',
  'Medical Supplies',
  'Fitness Equipment',
  'Supplements',

  'Sports & Outdoor',
  'Sports Equipment',
  'Fitness Gear',
  'Gym Equipment',
  'Yoga Mats',
  'Football',
  'Outdoor & Adventure',

  'Books',
  'Stationery',
  'Educational Tools',

  'Toys & Baby',
  'Toys',
  'Baby Products',
  'Baby Care',
  'Kids Accessories',
  'Action Figures',
  'Remote Control Cars',

  'Automotive',
  'Vehicle Accessories',
  'Spare Parts',
  'Tools & Equipment',
  'Helmets',

  'Office & Industrial',
  'Office Supplies',
  'Industrial Tools',
  'Printers',

  'Digital Products',
  'Software',
  'Subscriptions',
  'Gift Cards',

  'Pet Supplies',

  'Handmade Products',
  'Eco-Friendly Products',
  'Customized Products',
  'Collectibles'
];

// Order Status
export const ORDER_STATUS = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled'
};

// Payment Methods
export const PAYMENT_METHODS = [
  'Credit Card',
  'Debit Card',
  'PayPal',
  'Cash on Delivery',
  'UPI',
  'Bank Transfer'
];

// UPI Payment Details
export const UPI_ID = 'derojava07-1@oksbi';

// Bank Transfer Details
export const BANK_DETAILS = {
  bankName: 'Union Bank of India',
  accountNumber: '620902010021191',
  ifscCode: 'UBIN0562092'
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  CUSTOMER: 'customer'
};

// Pagination
export const ITEMS_PER_PAGE = 12;

// Shipping
export const FREE_SHIPPING_THRESHOLD = 100;
export const SHIPPING_COST = 10;
export const TAX_RATE = 0.18; // 18%

// Toast Messages
export const TOAST_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful!',
  LOGOUT_SUCCESS: 'Logged out successfully!',
  REGISTER_SUCCESS: 'Registration successful!',
  ADD_TO_CART: 'Added to cart!',
  REMOVE_FROM_CART: 'Removed from cart!',
  ADD_TO_WISHLIST: 'Added to wishlist!',
  REMOVE_FROM_WISHLIST: 'Removed from wishlist!',
  ORDER_SUCCESS: 'Order placed successfully!',
  UPDATE_SUCCESS: 'Updated successfully!',
  DELETE_SUCCESS: 'Deleted successfully!',
  ERROR: 'Something went wrong!',
};